import React from "react";
import IndexHeader from "./IndexHeader";
import { Navigate } from "ellipse/navigate/Navigate";

export interface IndexAboutProps {}

const IndexAbout: React.FC<IndexAboutProps> = (props: IndexAboutProps) => {

	const goToProduct = () => {
		Navigate.updateQueryParam("page", "products");
	};

	const goToServices = () => {
		Navigate.updateQueryParam("page", "services");
	};

	return (
		<div id="indexabout-container" className="xl:w-1/2">
			Combined Platforms is a SaaS (Software-As-A-Service) development company situated in Melbourne, Australia.
			<br />
			<br />
			Harnessing advanced AI-driven techniques, functional SaaS platforms can be efficiently designed, built and operated.
			<br />
			<br />
			Though a passion for automation, Combined Platforms builds custom platforms and software to stay on the cutting edge of these efficiencies.
			<br />
			<br />
			You can see these products on the{" "}
			<a className="cursor-pointer" onClick={goToProduct}>
				Products
			</a>{" "}
			page.
			<br />
			<br />
			Combined Platforms also provides development services which leverage these efficiencies to assist you to build your own SaaS platform.
			<br />
			<br />
			These services can be tailored to your organisations needs, whatever your purpose, industry, size or stage.
			<br />
			<br />
			These services are outlined on the{" "}
			<a className="cursor-pointer" onClick={goToServices}>
				Development Services
			</a>{" "}
			page.
			<br />
			<br />
			To start a conversation about how Combined Platforms can help your organisation, send an email to <b>admin@combinedplatforms.com</b>
			{"."}
		</div>
	);

};

export default IndexAbout;